const React = require('react');
const $ = require('jquery');
const logo = require('./images/logo.png');
const comLogo = require('./images/comLogo1.png');
const comLogo2 = require('./images/comLogo2.png');
const Dialog = require('../dialog/modal');
const Select =  require('../select/index');
const res = require('@common/res');
const Prompt = require('../dialog/prompt');
const Modal = require('../dialog/modal');
const Button = require('../button/index');
const utils = res.utils;
import moment from "moment";
//const moment = require("_moment@2.29.3@moment");
const ExportUtil = require("../export/exportUtil");

const css = require('./msg.css');
const cfg = res.cfg;
const com = res.com;
class Head extends React.Component {
    constructor(props) {
        super(props);
        utils.bindFunc(this, [
            'onCancelMsg','dateFormat','downloadMsgFile','prevMsg','nextMsg','comGetMsg','getLoginInfo','getNotifyStorageKey'
        ]);
        let params = {};
        params.pageSize = params.pageSize || 1;
        params.pageNo = params.pageNo || 1;
        params.isIndex = 1;
        this.state = {
            params: params,
            visible: {
                seasonYear: false,
                msg:false
            },
            seasonYear:'',
            seasonYearOk:'',
            show:'none',
            msgData: [],
            msgTotalPage: 0,
            accountId:'',
        }
    }

    componentDidMount() {
        // 获取导航栏默认seasonYear
      this.GetSeasonYearNme();
      this.getMessage();
      this.getLoginInfo();
    }
    //获得登陆用户信息
    getLoginInfo() {
        com.getJson({
            url: cfg.get('getUserInfo'),
            type: 'post',
            contentType: 'application/json',
        }).done(res => {
            this.setState({
                accountId: res.data.userId
            });
        }).fail(err => {

        });
    }

    mouseover(e)
    {
        let down = e.currentTarget.querySelector('.fp-sub-menu');
        if (down) {
            down.style.display = 'block';
        }
    }
    mouseout(e)
    {
        let down = e.currentTarget.querySelector('.fp-sub-menu');
        if (down) {
            down.style.display = 'none';
        }
    }

    // 获取导航栏默认seasonYear
    GetSeasonYearNme()
    {
        let p2 = com.getJson({
            url: cfg.get('GetSeasonYear'),
            type: 'post'
        }).done(res => {
            if (!res.data) {
                return;
            }
            let  seasonYearOk =res.data;
            window.seasonYear = res.data;
            this.setState({
                seasonYearOk:seasonYearOk,
                show:'inline-block'
            });
        }).fail(err => {
            Prompt.error('获取导航栏默认年份失败！' + err.codeMsg);
        });
    }
    dateFormat(time){
        return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }
    getNotifyStorageKey() {
        var pathPrefix = '/' + window.location.pathname.split('/')[1];
        return 'msgNotified_' + pathPrefix;
    }

    getMessage() {
        var _this = this;
        // 检查 localStorage 缓存，已关闭过则本次会话不再弹窗
        if (localStorage.getItem(this.getNotifyStorageKey())) {
            return;
        }
        var params = {};
        params.pageSize = 1;
        params.pageNo = params.pageNo || 1;
        params.isIndex = "1";
        _this.comGetMsg();
    }
    //下一条
    nextMsg(){
        let _this = this;
        let params = _this.state.params;
        let pageNo = params.pageNo;
        let msgTotalPage = _this.state.msgTotalPage;
        // console.log(params);
        // console.log("总页数：" + msgTotalPage);
        pageNo++;
        if(pageNo > msgTotalPage){
            Prompt.warn("当前已是最后一条消息通知");
            return;
        }
        params.pageNo = pageNo;
        _this.setState({
            params: params
        });
        _this.comGetMsg();
    }
    //上一条
    prevMsg(){
        let _this = this;
        let params = _this.state.params;
        let pageNo = params.pageNo;
        if(pageNo == 1){
            Prompt.warn("当前已是第一条消息通知");
            return;
        }
        params.pageNo = pageNo - 1;
        _this.setState({
            params: params
        });
        _this.comGetMsg();
    }
    //下载附件
    downloadMsgFile(){
        let getParam = {};
        let msgData = this.state.msgData || [];
        let fileList = msgData.fileList || [];
        let title = msgData.title;
        if(fileList.length < 1){
            Prompt.warn("此消息通知未上传有附件");
            return;
        }
        getParam.msgId = msgData.msgId;
        let param = {
            title:title,
            bizCode: "1e977989164041e4abce7809017c1ce6",
            accountId :this.state.accountId,
            exportType : "17", //zip文件导出
            args: getParam
        }
        let exportParam={
            title: '文件下载',
            content: '附件列表zip文件?',
            param
        };
        ExportUtil.exportCommon(exportParam);
    }
    comGetMsg(){
        let _this = this;
        let params = _this.state.params;
        com.getJson({
            url: cfg.get('getMessageList'),
            type: 'POST',
            data: JSON.stringify(params),
            contentType: 'application/json',
        }).done(res => {
            let datalist = res.page.dataList || [];
            let msgTotalPage = res.page.totalPage || 0;
            if(datalist.length > 0){
                _this.state.visible.msg = true;
            }else{
                return;
            }
            let fileList = datalist[0].fileList || [];
            let fileName = "";
            for(let j=0; j<fileList.length; j++){
                fileName += fileList[j].fileName + '\n';
            }
            datalist[0].filename = fileName;
            datalist[0].sendStartTime = moment(datalist[0].sendStartTime).format('YYYY-MM-DD');
            _this.setState({
                msgData:datalist[0],
                msgTotalPage:msgTotalPage
            });
            // console.log(datalist[0]);
        }).fail(err => {
            Prompt.error('获消息失败！' + err.codeMsg);
        });
    }
    openUploadModel() {
        let _this = this;
        _this.state.visible.seasonYear= true;
        _this.setState();
        // 获取榨季下拉列表
        let p1 = com.getJson({
            url: cfg.get('GetZjList'),
            type: 'post'
        }).done(res => {
            if (!res.data) {
                return;
            }
            let zjList = [];
            res.data.map(item => {
                zjList.push({
                    name: item.name,
                    value: item.seasonYear
                });
            });
            this.setState({
                zjList
            });
        }).fail(err => {
            Prompt.error('获取榨季列表失败！' + err.codeMsg);
        });
        this.forceUpdate();
    }

    onSelectChange(e) {
        var _this = this;
        _this.state.seasonYear = e.target.value;
        this.setState();
    }
    uploadCancel() {
        var _this = this;
        _this.state.visible.seasonYear = false;
        _this.setState();
    }

    uploadOK() {
        var _this = this;
        //5、点击确认切换
        let seasonYear=_this.state.seasonYear;
        if(!seasonYear){
            Prompt.warn('请选择榨季');
            return
        }
        _this.state.visible.seasonYear = false;
        if (seasonYear) {
            com.getJson({
                url: cfg.get('UpdateInfoEx'),
                data: JSON.stringify({
                    seasonYear: seasonYear
                }),
                type: 'post',
                contentType: 'application/json'
            })
                .done(json => {
                    let data = json.data;
                    if(data==1){
                        //_this.GetSeasonYearNme();
                        history.go(0)
                    }else {
                        Prompt.error('榨季切换失败！请重试');
                    }

                })
                .fail(error => {
                    Prompt.error('获取失败！请重试');
                    this.setState();
                });
        }
    }
    onCancelMsg(){
        var _this = this;
        _this.state.visible.msg = false;
        localStorage.setItem(this.getNotifyStorageKey(), '1');
        _this.setState();
    }
        render()
        {
            var userInfo = {};
            if (localStorage.userInfo && localStorage.userInfo != "") {
                userInfo = JSON.parse(localStorage.userInfo);
            }
            var msgData = this.state.msgData;
            return <div className='fp-head'>
                <Dialog visible={this.state.visible.seasonYear}
                    title='榨季切换'
                    style={{
                    'max-width': $(window).width() - 500,
                    'max-height': $(window).height() - 150,
                        'text-align': "center",
                        'top':'25%'
                }}
                        onCancel={this.uploadCancel.bind(this)}
                        onOk={this.uploadOK.bind(this)}
                    >
                    <Select
                        options={this.state.zjList}
                        className="select"
                        value={this.state.seasonYear}
                        name="dictId"
                        onChange={this.onSelectChange.bind(this)}
                    />
                </Dialog>
                <div className="fp-head-content">
                    <div className="fp-headLogo">
                        <img src={logo}/>
                        <p>广西糖料蔗大数据服务平台<i>{userInfo.departname || ""}</i></p>
                        <div className="switch"  style={{
                            'display':this.state.show
                        }}><span className="text">{this.state.seasonYearOk}</span>
                            <span className="button" onClick={this.openUploadModel.bind(this)}>切换榨季</span>
                            <span className="fp-friendlyLink"><a href="http://dbdc.gxzf.gov.cn/#/home" target="_blank">广西壮族自治区人民政府--互联网+督查</a></span>
                        </div>
                    </div>
                    {/*<a href="./index.html#/home"><img src={logo} className='fp-headLogo' width="510"/></a>*/}
                    <div className="fp-seach-wrap" style={{'text-align':'right'}}>
                        <div className="fp-userWarp">
                            {/* <img src={userIcon} />
                        <p>{this.props.userName}</p>
                        <div className='fp-drop-box'>
                            <ul className='fp-drop-item'>
                                <li><a onClick={this.props.editPassword}>修改密码</a></li>
                                <li><a onClick={this.props.logoutClick}>退出登录</a></li>
                            </ul>
                        </div> */}
                            <p style={{'text-align':'center'}}><a onClick={this.props.logoutClick}>退出登录</a></p>
                        </div>
                        {/*<div className="fp-comLogo">*/}
                        {/*    <a href='http://www.caih.com/' target="_blank"><img src={comLogo} className='comLogo'/></a>*/}
                        {/*</div>*/}
                        <div className="fp-comLogo">
                            <a href='https://www.hisugar.com/' target="_blank"><img src={comLogo2}
                                                                                    className='comLogo2' style={{'margin-right':'0px','width':'144px','height':'unset'}}/></a>
                        </div>
                        <div className='fp-userWarp2'>
                            <p>欢迎您，{this.props.userName}！&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
                                onClick={this.props.editPassword}>修改密码</a></p>
                        </div>
                    </div>
                    <ul className="fp-head-menu">
                        {
                            this.props.menu.map((item, index) => {
                                if (item.resType !== '00' && item.resType !== '01') {
                                    return null;
                                }
                                let showList = [];
                                if (item.children) {
                                    showList = item.children.filter(o => {
                                        return o && o.resType == '00' || o.resType == '01';
                                    });
                                }

                                return <li className="fp-head-menu-item"
                                           onMouseOver={this.mouseover}
                                           onMouseOut={this.mouseout}>
                                    <a href={showList.length > 0 ? 'javascript:;' : item.resUrl}
                                       className={'fp-menu-link'}>
                                    <span
                                        className={"fp-menu-icon-" + item.resIcon + (item.resourceId == this.props.activeId ? ' fp-menu-cur' : '')}>
                                        {(item.resourceId == "/resourceId/mine.html" && this.props.userName) ?
                                            (this.props.userName.length > 5 ? this.props.userName.substr(0, 5) + '...' : this.props.userName)
                                            : item.title
                                        }
                                    </span>
                                        {showList.length > 0 ? <i></i> : null}
                                    </a>
                                    {
                                        showList.length > 0 ?
                                            <ul className="fp-sub-menu">
                                                {
                                                    item.children.map((ele, i) => {
                                                        return <li><a href={ele.resUrl}>{ele.title}</a></li>;
                                                    })
                                                }
                                                {
                                                    item.resourceId == "/resourceId/mine.html" ?
                                                        <li className="fp-loginOut-btn"><a
                                                            onClick={this.props.logoutClick}>退出</a></li> : null
                                                }
                                            </ul>
                                            : null
                                    }
                                </li>;
                            })
                        }
                    </ul>
                </div>
                <Modal
                    visible={this.state.visible.msg}
                    title='消息通知'
                    onCancel={this.onCancelMsg}
                    style={{
                        'width': 760,
                        'height': 640
                    }}
                    footer={null}
                >
                    <div className="fp-msg">
                        <div className='div-title-username'>
                            <h2>{msgData.title}</h2>
                            <span>发送人：{msgData.addusername}</span> <span>发布时间：{msgData.sendStartTime}</span>
                        </div>
                        <br />
                        <br />
                        <span className='msgtype'>{msgData.msgTypeName}</span>
                        <p><pre className='pre-content'>{msgData.content}</pre></p>
                        <hr />
                        <div className="msg-file">
                            <div className='div-file'>附件：<pre>{msgData.filename}</pre></div>
                            <Button
                                style="primary"
                                className='download'
                                text='下载附件'
                                onClick={this.downloadMsgFile}
                            />
                        </div>
                        <div className="but_div">
                            <Button
                                style="yellow"
                                text='上一条'
                                className='prev'
                                onClick={this.prevMsg.bind(this)}
                            />
                            <Button
                                style="yellow"
                                text='下一条'
                                className='next'
                                onClick={this.nextMsg.bind(this)}
                            />
                        </div>
                    </div>
                </Modal>
            </div>;
        }
}
module.exports = Head;







// WEBPACK FOOTER //
// ./component/frame/head.js